import { pendulum } from './models/pendulum.js';
import { collision } from './models/collision.js';
import { incline } from './models/incline.js';
import { circular } from './models/circular.js';

export const experimentRegistry = {
  pendulum,
  collision,
  incline,
  circular,
};

export const experiments = [pendulum, collision, incline, circular].sort((a, b) => a.order - b.order);
export const experimentIds = experiments.map((item) => item.id);

export function getExperiment(id) {
  return experimentRegistry[id] ?? pendulum;
}

export { pendulum, collision, incline, circular };
export { SimulationRunner } from './runner.js';
export { DiagnosticsCenter } from './diagnostics.js';
export { evaluateConservation, worstDefect } from './conservation.js';
export {
  defaultsFor,
  normalizeParams,
  paramField,
  paramsEqual,
  formatParam,
} from './params.js';
export {
  TAU,
  DEG,
  RAD,
  clamp,
  lerp,
  isFiniteNumber,
  nearlyEqual,
  relativeError,
  signedRelativeDelta,
  round,
  formatNumber,
  formatSigned,
  mulberry32,
  hashString,
  arithmeticGeometricMean,
  rk4,
  allFinite,
} from './math.js';
export {
  collisionOutcome,
  kineticEnergy,
  COLLISION_DIAMETER,
  TRACK_HALF_LENGTH,
} from './models/collision.js';
export { inclineAcceleration, isStaticEquilibrium } from './models/incline.js';
